<template>
  <div>
    <head-top></head-top>
    <el-row style="margin-top: 20px;">
      <el-col :span="24">
        <el-form :model="formData"  ref="formData" label-width="120px" class="demo-formData">
          <el-form-item label="团购名称:" prop="name">
            <el-input v-model="groupName"  maxlength="15" style="width: 200px"></el-input>
            <el-button size="small" type="primary" @click="preservation" v-show="id == ''">保存</el-button>
          </el-form-item>
          <el-form-item label="团购封面:"  v-show="id != ''">
            <el-upload
              class="avatar-uploader"
              action="http://gapi.eduscb.com/api/drawing/common/upload/oss"
              :before-upload="beforeUploadimg"
              :show-file-list="false"
              :on-success='groupimgsuccess'
              :data = "{fileType:1}">
              <img v-if="groupimg" :src="groupimg" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <div class="el-upload__tip" slot="tip">数量：1张; 尺寸：800*800; 大小：200kb以内</div>
            </el-upload>
          </el-form-item>
          <el-form-item label="分享海报:"  v-show="id != ''">
            <el-upload
              class="avatar-uploader"
              action="http://gapi.eduscb.com/api/drawing/common/upload/oss"
              :before-upload="beforeUploadimg"
              :show-file-list="false"
              :on-success='posterimgsuccess'
              :data = "{fileType:2}">
              <img v-if="posterimg" :src="posterimg" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <div class="el-upload__tip" slot="tip">数量：1张; 尺寸：800*800; 大小：200kb以内</div>
            </el-upload>
          </el-form-item>
          <el-form-item label="团购banner" v-show="id != ''">
            <el-upload
              class="avatar-uploader"
              action="http://gapi.eduscb.com/api/drawing/common/upload/oss"
              list-type="picture-card"
              :on-success='posterimgCardsuccess'
              :before-upload="beforeUploadimg"
              :on-remove="handleRemove"
              :file-list="fileList"
              :data = "{fileType:3}">
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="单独全价:" v-show="id != ''">
            <input v-model="singlePrice" maxlength="6" type="number" @input="oninput(singlePrice)"  style="width: 183px;height: 38px;border: 1px solid #c0c4cc;font-size: 14px;padding-left: 15px" />
            <span style="margin-left: 30px">三人团价：</span>
            <input v-model="groupPrice" maxlength="6" type="number" @input="oninputs(groupPrice)"  style="width: 183px;height: 38px;border: 1px solid #c0c4cc;font-size: 14px;padding-left: 15px" />
          </el-form-item>

          <!--图文教程-->
          <el-form-item label="简介" v-show="id != ''">
            <el-button size="small" type="primary" :disabled="onshow" @click="addCourse">添加视频</el-button>

          </el-form-item>
          <el-table
            v-show="id != ''"
            :data="tableData"
            style="width: 100%;margin-left:60px;">
            <el-table-column
              type="index"
              label="序号"
              width="180">
            </el-table-column>
            <el-table-column
              prop="goodsName"
              label="视频名称">
            </el-table-column>
            <el-table-column
              prop="timeLength"
              label="时长">
            </el-table-column>
            <el-table-column
              label="操作">
              <template slot-scope="scope">
                <el-button size="mini" type="text" :disabled="onshow" @click="Editmaterials(scope.$index, scope.row)">编辑</el-button>
                <el-button size="mini" type="text" :disabled="onshow" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-form-item label="添加课程介绍" style="margin-top: 30px" v-show="id != ''">
            <el-upload
              class="avatar-uploader"
              action="http://gapi.eduscb.com/api/drawing/common/upload/oss"
              :before-upload="beforeUploadimg"
              list-type="picture-card"
              :on-success='posterimgCardsuccess2'
              :on-remove="handleRemove2"
              :file-list="fileList2"
              :data = "{fileType:3}">
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
          <div class="but_bot" v-show="id != ''">
            <el-button type="primary" @click="submit()">提交</el-button>
            <el-button type="primary" @click="cancel()">取消</el-button>
          </div>
        </el-form>
      </el-col>
    </el-row>
    <groupCourse ref="groupCourse" :panelShow.sync="panelShow" v-if="panelShow" v-on:goodsList="goodsList"  v-on:goodsLists="goodsLists" v-bind:goodsId="goodsId"></groupCourse>
  </div>
</template>

<script>
  import headTop from '@/components/headTop'
  import groupCourse from '@/components/groupCourse'
  import axios from 'axios'
  import { getGroupDetail,getAddGroup,getgroupedit } from "../api/api"
  export default {
    inject: ['reload'],
    data(){
      return {
        formData:{},
        groupName:'',
        singlePrice:' ',
        groupPrice:' ',
        id:'',
        groupimg:'',//团购封面
        posterimg:'',//分享海报
        fileList:[],//团购banner
        fileList2:[],//课程介绍
        groupimgs:[],
        posterimgs:[],
        tableData:[],
        goodList:[],
        myHeaders: {token: sessionStorage.token},
        goodsId:'',
        panelShow:false,
        onshow:false
      }
    },
    components: {
      headTop,groupCourse
    },
    methods:{
      goodsList(data){
        this.goodList.push(data)
      },
      goodsLists(data){
        this.tableData.push(JSON.parse(JSON.stringify(data).replace(/courseName/g,"goodsName")))
      },
      addCourse() {
        this.goodsId = ''
        this.panelShow = true;
      },
      Editmaterials(index,row){
        console.log(row)
        this.goodsId = row.goodsId
        this.panelShow = true;
      },
      oninput(singlePrice){
        this.singlePrice = (singlePrice.match(/^\d*(\.?\d{0,2})/g)[0]) || null
      },
      oninputs(groupPrice){
        this.groupPrice = (groupPrice.match(/^\d*(\.?\d{0,2})/g)[0]) || null
      },
      preservation(){
        if (this.groupName == ''){
          this.$message({
            type: 'success',
            message: '请输入团购名称'
          });
        }else {
          let params={
            strategyTitle:this.groupName,
          };
          getAddGroup(params).then(res=>{
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: res.msg
              });
              this.id = res.data
              this.groupimg = '',//团购封面
              this.posterimg = '',//分享海报
              this.fileList = [],//团购banner
              this.fileList2 = [],//课程介绍
              this.groupimgs = [],
              this.posterimgs = [],
              this.tableData = []
              this.goodList = []
              this.singlePrice = '',
              this.groupPrice = ''
            }else{
              this.$message({
                type: 'error',
                message: res.msg
              });
            }
          }).catch(error=>{
            console.log(error);
          })
        }

      },
      //上传团购封面
      groupimgsuccess(response, file, fileList){
        if(file.response.code == 200){
          this.groupimg = file.response.data
        }else{
          this.$message.error('图片上传失败');
        }
      },

      //上传分享海报
      posterimgsuccess(response, file, fileList){
        if(file.response.code == 200){
          this.posterimg = file.response.data
        }else{
          this.$message.error('图片上传失败');
        }
      },
      //团购banner
      posterimgCardsuccess(response, file, fileList){
        if(file.response.code == 200){
          let arr = {bannerImgUrl:file.response.data}
          this.groupimgs.push(arr)
        }else{
          this.$message.error('图片上传失败');
        }
      },
      handleRemove(file, fileList) {
        //this.ruleForm.courseDespSources=fileList
        let arr=[]
        fileList.forEach(function(item,index){
          if(item.response){
            arr.push(item.response.data)
          }else{
            let arrs = {id:item.id,bannerImgUrl:item.url}
            arr.push(arrs)
          }
        })
        this.groupimgs = arr
        let params={
          courseImgId:'',
          groupGoodsId:'',
          groupStrategyBannerId:file.id,
          id:this.id
        };
        axios({
          method:"put",
          url:'http://gapi.eduscb.com/api/drawing/group/strategy/deleteDetail',
          data:params,
          headers:{'Content-Type':'application/json;charset=utf-8'}
        }).then(res=>{
          this.$message({
            type: 'success',
            message: res.data.msg
          });
        }).catch(error=>{
          console.log(error);
        })

      },
      //课程介绍
      posterimgCardsuccess2(response, file, fileList){
        if(file.response.code == 200){
          let arr = {courseImgUrl:file.response.data}
          this.posterimgs.push(arr)
        }else{
          this.$message.error('图片上传失败');
        }
      },
      beforeUploadimg(file) {
        if (['image/jpg', 'image/png', 'image/jpeg'].indexOf(file.type) == -1) {
          this.$message.error('请上传png或jpg格式图片');
          return false
        }
      },
      handleRemove2(file, fileList) {
        //this.ruleForm.courseDespSources=fileList
        let arr=[]
        fileList.forEach(function(item,index){
          if(item.response){
            arr.push(item.response.data)
          }else{
            let arrs = {id:item.id,courseImgUrl:item.url}
            arr.push(arrs)
          }
        })
        this.posterimgs = arr
        let params={
          courseImgId:file.id,
          groupGoodsId:'',
          groupStrategyBannerId:'',
          id:this.id
        };
        axios({
          method:"put",
          url:'http://gapi.eduscb.com/api/drawing/group/strategy/deleteDetail',
          data:params,
          headers:{'Content-Type':'application/json;charset=utf-8'}
        }).then(res=>{
          this.$message({
            type: 'success',
            message: res.data.msg
          });
        }).catch(error=>{
          console.log(error);
        })
      },
      //保存团购
      submit(){
        if (this.$route.query.type==1) {
          this.id = this.$route.query.id
        }else {
          this.id = this.id
        }
        if (this.singlePrice == '0' || this.groupPrice == '0'){
          this.$message({
            type: 'error',
            message: '价格不能为0'
          });
          return
        }
        if (this.groupimg == '' || this.goodList == [] || this.groupimgs == [] || this.posterimgs == [] || this.groupPrice == '' || this.posterimg == '' || this.singlePrice == '' || this.groupName == '') {
          this.$message({
            type: 'error',
            message: '请输入完整信息'
          });
        }else {
          let params={
            coverImgUrl:this.groupimg,
            drawingGroupGoodsSaveParams:this.goodList,
            drawingGroupStrategyBannerSaveParams:this.groupimgs,
            drawingGroupStrategyCourseImageSaveParams:this.posterimgs,
            groupPrice :this.groupPrice,
            id:this.id,
            maxBuyerNum :3,
            shareImgUrl:this.posterimg,
            singlePrice :this.singlePrice,
            strategyTitle:this.groupName
          };
          axios({
            method:"put",
            url:'http://gapi.eduscb.com/api/drawing/group/strategy/json',
            data:params,
            headers:{'Content-Type':'application/json;charset=utf-8'}
          }).then(res=>{
            this.$message({
              type: 'success',
              message: res.data.msg
            });
            this.$router.back(-1);
          }).catch(error=>{
            console.log(error);
          })
        }

      },
      cancel(){
        this.$router.back(-1);
      },
      handleDelete(index, row){
        //删除
        this.$confirm('确认删除该记录吗？', '提示', {
          // type: 'warning'
        }).then(() => {
          let params={
            courseImgId:'',
            groupGoodsId:row.goodsId,
            groupStrategyBannerId:'',
            id:this.id
          };
          axios({
            method:"put",
            url:'http://gapi.eduscb.com/api/drawing/group/strategy/deleteDetail',
            data:params,
            headers:{'Content-Type':'application/json;charset=utf-8'}
          }).then(res=>{
            this.$message({
              type: 'success',
              message: res.data.msg
            });
            this.tableData.splice(index, 1);
            this.goodList.splice(index, 1)
          }).catch(error=>{
            console.log(error);
          })
        })
      },
    },
    activated () {
      this.panelShow = false
      this.id = ''
      this.groupName = ''
      this.singlePrice=''
      this.groupPrice=''
      this.goodList = []
      if (this.$route.query.status==2) {
        this.onshow = true
      }else {
        this.onshow = false
      }
      if (this.$route.query.type==1){
        this.id = this.$route.query.id
        let params = {
          id:this.$route.query.id
        }
        getGroupDetail(params).then(res=>{
          if (res.code == 200) {
            this.groupName = res.data.strategyTitle
            this.groupimg = res.data.coverImgUrl
            this.fileList = JSON.parse(JSON.stringify(res.data.drawingGroupStrategyBannerList).replace(/bannerImgUrl/g,"url"))
            this.groupimgs = res.data.drawingGroupStrategyBannerList
            this.posterimg = res.data.shareImgUrl
            this.singlePrice = res.data.singlePrice
            this.groupPrice = res.data.groupPrice
            this.fileList2 = JSON.parse(JSON.stringify(res.data.drawingGroupStrategyCourseImageList).replace(/courseImgUrl/g,"url"))
            this.posterimgs = res.data.drawingGroupStrategyCourseImageList
            this.tableData = res.data.drawingGroupGoodsList
            for (let i = 0; i < res.data.drawingGroupGoodsList.length; i++) {
              let drawingGroupGoodsSaveParams = {
                goodsCount: 1,
                goodsId: res.data.drawingGroupGoodsList[i].goodsId,
              }
              this.goodList.push(drawingGroupGoodsSaveParams)
            }
          }else{
            this.$message({
              type: 'error',
              message: res.msg
            });
          }
        }).catch(error=>{
          console.log(error);
        })
      }

    },

  }
</script>
<style lang="less">
  input[type=number]::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
  .number__input {
    border: 1px solid #ccc;
  }
</style>



// WEBPACK FOOTER //
// src/page/addgroup.vue